import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzLayoutModule } from 'ng-zorro-antd/layout'
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';

import { MmLayoutConfig } from './layout-config';
import { RouterModule, Routes } from '@angular/router';
import { MmSpinModule } from '../spin'
import { MmAppComponent } from './components/page/page.component';


import { MmIdentityModule } from '../identity';
import { MmPageHeaderComponent } from './components/page-header/page-header.component';
import { MmPageBodyComponent } from './components/page-body/page-body.component';
import { AppSiderHeaderComponent } from './components/sider-header/sider-header.component';
import { MmMenuModule } from '../menu/menu.module';
import { MmSiderMenuComponent } from './components/sider-menu/sider-menu.component';
import { MmI18nModule } from '../i18n';
import { PageFooterComponent } from './components/page-footer/page-footer.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { SharedModule } from 'shared';



@NgModule({
  declarations: [
    MmAppComponent,
    MmSiderMenuComponent,
    MmPageHeaderComponent,
    MmPageBodyComponent,
    PageFooterComponent,
    AppSiderHeaderComponent,
    PageFooterComponent
  ],
  imports: [
    MmSpinModule,
    CommonModule,
    NzLayoutModule,
    NzIconModule,
    NzMenuModule,
    RouterModule,
    MmIdentityModule,
    MmMenuModule,
    MmI18nModule,
    NzDropDownModule,
    NzButtonModule,
    NzTabsModule,
    NzToolTipModule,
    SharedModule
  ],
  exports: [
    MmAppComponent,
    MmPageHeaderComponent,
    AppSiderHeaderComponent,
    MmPageBodyComponent,
    PageFooterComponent,
    NzMenuModule,
    NzLayoutModule
  ]
})
export class MmLayoutModule {


}

